import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    coachId: "",
  },
  reducers: {
    setCoachId: (state, action: PayloadAction<string>) => {
      state.coachId = action.payload;
    },
  },
});

export const { setCoachId } = authSlice.actions;

export default authSlice.reducer;
